import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  city: 'Ciudad de México'
}, {
  name: 'Valentina R.',
  city: 'Bogotá'
}, {
  name: 'Camila S.',
  city: 'Buenos Aires'
}, {
  name: 'Sofía L.',
  city: 'Lima'
}, {
  name: 'Isabella M.',
  city: 'Madrid'
}, {
  name: 'Luciana P.',
  city: 'Santiago'
}, {
  name: 'Andrea T.',
  city: 'Medellín'
}, {
  name: 'Daniela F.',
  city: 'Guadalajara'
}, {
  name: 'Fernanda H.',
  city: 'Quito'
}, {
  name: 'Gabriela V.',
  city: 'Monterrey'
}, {
  name: 'Paula C.',
  city: 'Barcelona'
}, {
  name: 'Carolina A.',
  city: 'Santo Domingo'
}];
function getRandomBuyer() {
  return buyers[Math.floor(Math.random() * buyers.length)];
}
function getTimeAgo() {
  const minutes = Math.floor(Math.random() * 15) + 1;
  return `hace ${minutes} min`;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(getRandomBuyer());
  const [timeAgo, setTimeAgo] = useState(getTimeAgo());
  const showNext = useCallback(() => {
    setBuyer(getRandomBuyer());
    setTimeAgo(getTimeAgo());
    setVisible(true);
  }, []);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      showNext();
    }, 4000);
    return () => clearTimeout(initialDelay);
  }, [showNext]);
  useEffect(() => {
    if (!visible) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 6000);
    const nextTimer = setTimeout(() => {
      showNext();
    }, 10000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [visible, buyer, showNext]);
  return <AnimatePresence data-id="element-263">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 100,
      scale: 0.8
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 60,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-5 left-5 z-50 w-[340px] max-w-[calc(100vw-40px)]" data-id="element-264">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-brand-rose/20 rounded-2xl blur-lg pointer-events-none" data-id="element-265" />

          <div className="relative bg-[#1c1c1c] border border-brand-rose/30 rounded-2xl shadow-[0_8px_40px_rgba(225,29,72,0.25)] p-4 flex items-center gap-4" data-id="element-266">
            {/* Product image 1:1 */}
            <div className="w-[72px] h-[72px] rounded-xl overflow-hidden shrink-0 border-2 border-brand-rose/40 shadow-lg" data-id="element-267">
              <img src="https://cdn.magicpatterns.com/uploads/sL1pDaDyzYLntnvcP3mhMv/Nunca_mas_te_dejan_en_visto.png" alt="Producto" className="w-full h-full object-cover" data-id="element-268" />
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0" data-id="element-269">
              <div className="flex items-center gap-1.5 mb-1" data-id="element-270">
                <ShoppingBag className="w-3.5 h-3.5 text-brand-rose" data-id="element-271" />
                <p className="text-brand-rose text-xs font-bold uppercase tracking-wide" data-id="element-272">
                  Nueva compra
                </p>
              </div>
              <p className="text-brand-cream text-base font-bold truncate" data-id="element-273">
                {buyer.name}
              </p>
              <p className="text-brand-lightGray text-sm mt-0.5" data-id="element-274">
                compró por{' '}
                <span className="text-white font-extrabold text-base" data-id="element-275">
                  $24.000 COP
                </span>
              </p>
              <p className="text-brand-lightGray/60 text-xs mt-1.5 flex items-center gap-1.5" data-id="element-276">
                <span className="relative flex h-2 w-2" data-id="element-277">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-278" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-279" />
                </span>
                {buyer.city} · {timeAgo}
              </p>
            </div>

            {/* Close button */}
            <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-brand-lightGray/30 hover:text-brand-lightGray transition-colors text-sm leading-none p-1" aria-label="Cerrar" data-id="element-280">
              ✕
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}